export default __webpack_public_path__ + "static/media/HOSxPost_2.eb9c2d67.jpg";